
// const objectsApi = new ItObjectsApi()
// import ItObjectsApi from '@/api/itObjectsApi'
import SettingsApi from '@/api/settingsApi'
const settingsApi = new SettingsApi()
import ApplicationApi from '@/api/applicationApi'
const applicationApi = new ApplicationApi()
import { AbilityBuilder } from '@casl/ability'
import Vue from 'vue'
import { eventBus } from '@/main'
import IndexedDBService from '@/helpers/IndexedDBService'

const actions = {
  async LOGIN ({dispatch}, payload) {
    settingsApi.userSignedInEvent()
    await dispatch('setSettings', payload)

    //Vue.prototype.$time('connectNotifiacationHub') // TODO: perfomance test
    await Vue.prototype.$notifier.checHub()
    //Vue.prototype.$timeEnd('connectNotifiacationHub') // TODO: perfomance test
  },

  LOGOUT ({commit}) {
    return new Promise((resolve) => {
      commit('CLEAR_USER')
      sessionStorage.removeItem('OrganizationItId')
      commit('clearAvailableOrganizations' )
      // dispatch('clearAvailableOrganizations')
      resolve()
    })
  },
  async setPurchaseSettings({commit, state, dispatch}, payload) {
    await applicationApi.getPurchaseSettings()
      .then(async res => {
        if (res?.data?.purchaseSettings) {
          commit('setPurchasingSettings', res.data.purchaseSettings)
        } else {
          commit('setPurchasingSettings', null)
        }

        state.current_user.purchasingSettings = res || {}
        commit('SET_USER', Object.assign(state.current_user, state.settings?.userProfile))
        await dispatch('setPurchCredentials', { acl: payload.acl })
      })
  },

  async getAllOrgSettings({state, dispatch}) {
    const showServiceMessage = false//['development', 'staging'].includes(window.config?.node_env)

    if (showServiceMessage) { Vue.prototype.$sinfo('Початок логіки кешу налаштувань') }
    const userLogin = state.current_user?.login || 'none'
    if (showServiceMessage) { Vue.prototype.$sinfo('Поточний користувач', userLogin) }
    IndexedDBService.setCacheKey(userLogin)
    if (showServiceMessage) { Vue.prototype.$sinfo('Структура сформована') }
    let hasStorageError = await IndexedDBService.getItem(IndexedDBService.storeNames.dopProps, 'errorState', false)
    hasStorageError = hasStorageError === 'false' ? false : hasStorageError

    let cachedData = []
    if (hasStorageError) { // если есть ошибка, считываем сохраненные настройки
      if (showServiceMessage) { Vue.prototype.$sinfo('Виявлено попередню помилку.') }
      let keyByDelete = await IndexedDBService.readAllItems(IndexedDBService.storeNames.changedKeys)

      keyByDelete = keyByDelete
        .filter(item => item && item.state === 'delete')
        .map(item => item.key)
      if (showServiceMessage) { Vue.prototype.$sinfo('Ключі на видаленя', keyByDelete) }

      let deleteResult = true
      if (keyByDelete?.length) {
        deleteResult = await IndexedDBService.processChangedKeysDelete(keyByDelete)
      }
      if (!deleteResult) {
        if (showServiceMessage) { Vue.prototype.$serror('Помилка збереження раніше видалених ключів') }
        return
      } else if (showServiceMessage) {
        Vue.prototype.$sinfo('Успішно зберегли раніше видалені ключі')
      }
      try {
        cachedData = await IndexedDBService.readAllItems('itemProps')
        if (showServiceMessage) { Vue.prototype.$sinfo('Налаштування з кешу', cachedData) }
      } catch (e) {
        if (showServiceMessage) { Vue.prototype.$serror('Помилка при читанні з кешу:', e) }
      }

      if (cachedData?.length > 0) {
        if (showServiceMessage) { Vue.prototype.$sinfo('Спроба синхронізувати кешу з БД.') }
        try {
          cachedData = cachedData?.map((resultItem) => {
            delete resultItem.dateCreated
            delete resultItem.__typename
            return resultItem
          })
          await IndexedDBService.clearStore('changedKeys')
          const result = await settingsApi.setManyDBStorage(cachedData)
          if (showServiceMessage) { Vue.prototype.$sinfo('setManyDBStorage result', result) }
          if (result) {
            IndexedDBService.setItem(IndexedDBService.storeNames.dopProps, {key: 'errorState', value: false})
            hasStorageError = false
            if (showServiceMessage) { Vue.prototype.$sinfo('Успішно синхронізовано кешу з БД. Помилка скинута.') }
            return
          } else {
            if (showServiceMessage) { Vue.prototype.$serror('Помилка синхронізувати кешу з БД') }
          }
        } catch (e) {
          if (showServiceMessage) { Vue.prototype.$serror('Помилка синхронізації кешу з БД:') }
        }
      } else {
        IndexedDBService.setItem(IndexedDBService.storeNames.dopProps, {key: 'errorState', value: false})
        if (showServiceMessage) { Vue.prototype.$sinfo('Сохраненных настроек нет') }
      }
      if (hasStorageError) {
        return
      }
    }

    if (showServiceMessage) { Vue.prototype.$sinfo('Помилок не було') }
    try {
      const allDBStorage = await settingsApi.getAllDBStorage()
      if (showServiceMessage) { Vue.prototype.$sinfo('данные считали') }
      await IndexedDBService.clearStore('itemProps')
      if (showServiceMessage) { Vue.prototype.$sinfo('базу очистили') }
      allDBStorage.map(storageItem => {
        delete storageItem.__typename
      })
      if (allDBStorage?.length) {
        await IndexedDBService.setItems('itemProps', allDBStorage)
      }
      if (showServiceMessage) { Vue.prototype.$sinfo('данные сохранили') }

      IndexedDBService.setItem(IndexedDBService.storeNames.dopProps, {key: 'errorState', value: false})
    } catch (e) {
      if (showServiceMessage) { Vue.prototype.$serror('Помилка при отриманні даних з БД. Використовуємо кеш.') }

      IndexedDBService.setItem(IndexedDBService.storeNames.dopProps, {key: 'errorState', value: true})
    }
    await dispatch('dbStore/setLoadedStoreProp')
  },

  async setSettings({commit, state, dispatch}, payload) {
    await settingsApi.getSettings()
      .then(res => {
        //Vue.prototype.$time('setSettings') // TODO: perfomance test
        const setOrgTitle = (orgs) => {
          orgs.forEach(org => {
            let short = org?.shortTile,
              title =  org?.title

            const labelTitle = (short || title) ? (short || title) : ''
            const labelOkpo = org?.oKPO ? ` (${org?.oKPO})` : ''
            org.titleWithoutOkpo = org.title
            org.title = labelTitle ? `${labelTitle}${labelOkpo}` : ''
          })
          return orgs
        }

        let settings = res.data.settings || res.data.settings,
          orgs = setOrgTitle(settings.availableOrganizations)

        commit('setSettings', settings)
        commit('setTendersSettings', settings.tenderSettings)

        commit('setAvailableOrganizations', orgs )

        const personalTimeZone = {
          use: false,
          organizerTimezone: 'Europe/Kiev'
        }
        const organizerTimezone = settings?.tenderSettings?.organizerTimezone
        if (organizerTimezone && organizerTimezone !== 'Europe/Kiev') {
          personalTimeZone.use = true
          personalTimeZone.organizerTimezone = organizerTimezone
        }

        commit('setPersonalTimeZone', personalTimeZone)

        const sessionStorageOrganizationItId = sessionStorage.getItem('OrganizationItId'),
          sessionOrd = orgs.find(i => i.organizationItId.toString() === sessionStorageOrganizationItId),
          routeOrdId = payload.router?.history?.pending?.params?.org,
          routeOrd = orgs.find(i => i.organizationItId == routeOrdId),
          defaultOrg = orgs.find(i => i.isDefault),
          chckOrg = ( org) => {
            if ( org ) {
              sessionStorage.setItem('OrganizationItId', org?.organizationItId)
              eventBus.$emit('organizationUpdate', org)

              commit('setCurrentOrganization', org)
            } else if (defaultOrg) {                // прийде помилка з бека - ORGANIZATION_ACCESS_ERROR
              commit('setCurrentOrganization', defaultOrg)
            }
          }

        if (routeOrdId) {
          chckOrg ( routeOrd )
        } else if (sessionStorageOrganizationItId) { //todo первірити чи в цьому випадку не прийде така ж помилка
          chckOrg(sessionOrd)

        } else if (defaultOrg) {
          sessionStorage.setItem('OrganizationItId', defaultOrg?.organizationItId)
          eventBus.$emit('organizationUpdate', defaultOrg)
          commit('setCurrentOrganization', defaultOrg)
        }

        //Vue.prototype.$timeEnd('setSettings') // TODO: perfomance test

      })
      .catch(() => {
        commit('setSettings', null )
        // payload.acl.change('no_access')
      })

    //Vue.prototype.$time('SET_USER') // TODO: perfomance test
    commit('SET_USER', Object.assign(payload.user || state.current_user, state.settings?.userProfile))
    //Vue.prototype.$timeEnd('SET_USER') // TODO: perfomance test

    if (state.settings?.userAccess?.accessType === 'ALLOW') {
      await dispatch('setGrowthBook')
      dispatch('getAllOrgSettings')
    }

    //Vue.prototype.$time('setCredentials') // TODO: perfomance test
    const settings = await dispatch('setCredentials', { acl: payload.acl })
    //Vue.prototype.$timeEnd('setCredentials') // TODO: perfomance test
    //Vue.prototype.$time('setMenu') // TODO: perfomance test
    await dispatch('setMenu', { acl: payload.acl, router: payload.router, settings })
    //Vue.prototype.$timeEnd('setMenu') // TODO: perfomance test
  },

  async setPurchCredentials({state}, payload) {
    const { can, cannot, rules } = new AbilityBuilder()

    let settings = state.current_user?.purchasingSettings || {}

    const purchaseSettings = settings?.purchaseSettings || {}
    const purchasingUser = settings?.purchasingUser || {}

    //Наличие типа даты \"Не важно\" в строках заявки
    //Нигде не используется, но оставляем для совместимости
    /*if (purchaseSettings?.hasNonrequredDate ) {
      can('choose', 'NonrequredDate')
    } else {
      cannot('choose', 'NonrequredDate')
    }*/

    //Наличие процесса согласования заявки
    if (purchaseSettings?.hasOwnAgreementsProcess ) {
      can('have', 'AgreementsProcess')
    } else {
      cannot('have', 'AgreementsProcess')
    }

    //Отключена возможность добавлять ресурсы
    if (purchaseSettings?.disableAddResources ) {
      cannot('add', 'appResources')
    } else {
      can('add', 'appResources')
    }

    const roles = [...payload.acl.get]

    if (purchasingUser?.accessRoles?.some(it => it.trim() == 'IT')) {
      roles.push('IT')
    }

    payload.acl.change(roles)
    Vue.prototype.$ability.update(rules)
  },
  async setGrowthBook({commit}) {
    await settingsApi.growthbookFeatures().then( res => {
      if (res) {
        commit('setGrowthBook', res)
      }
    })
  },
  async setCredentials({state}, payload) {
    const { can, cannot, rules } = new AbilityBuilder()
    let settings = state.settings || {},
      hasTenders = settings.hasTenderAccess,
      hasContracting = settings.hasContractingAccess,
      hasPurchasing  = settings.hasPurchasingAccess,
      st_settings = settings.tenderSettings, // false //
      current_user = state.current_user,
      user_tender_set = current_user?.tenderSettings,
      role,
      roles = []
      // addToRoles = (role) => {
      //   if (roles.length) {
      //     roles.push(role)
      //   } else {
      //     roles = [role]
      //   }
      // }

    payload.acl.change('load')

    if (hasTenders) {
      const onlyViewRoles = ['COMMERCIALORGANIZERVIEWERBYCOMPANY', 'COMMERCIALORGANIZERVIEWERBYDEPARTMENT', 'COMMERCIALAGREEMENT']
      if (user_tender_set?.accessRole?.some(el => onlyViewRoles.includes(el)) ) { //tenderProfile?.accessRoles?.some(el => el == 'COMMERCIALORGANIZERVIEWERBYCOMPANY' )  ) {
        roles = ['tenders_view']
      } else if (user_tender_set?.accessRole?.some(el => el === 'COMMERCIALORGANIZERSECURITYDEPARTMENTEMPLOYEE')) {
        roles = ['security']
      } else {
        roles = ['only_tenders']
      }
    }

    if (user_tender_set?.accessRole?.some(el => el === 'COMMERCIALAGREEMENT') ) {
      roles.push('commercialAgreement')
    }

    if (hasPurchasing) {
      role = 'only_purchasing'
      roles.push(role)
    }

    if (hasContracting) {
      can('access', 'contracting')
    }

    if ( st_settings?.blackListMode ) { // Disable / View / Edit
      switch (st_settings.blackListMode) {
      case 'VIEW': {
        role = 'stop_list_view'
        break
      }

      case 'EDIT': {
        role = 'stop_list_edit'
        break
      }

      default: {
        role = ''
        break
      }
      }
      roles.push(role)
    }

    if (roles.includes('only_tenders') && roles.includes('only_purchasing') && roles.includes('stop_list_edit') ) {
      roles = ['user']
    } else if ( !roles.length ) {
      roles = ['no_access']
    }

    if (user_tender_set?.accessRole?.some(it => it.trim() == 'COMMERCIALORGANIZERCOMPANYADMIN')) {
      roles.push('tenderAdmin')
    }
    if (user_tender_set?.accessRole?.some(it => it.trim() == 'COMMERCIALORGANIZERONLYMYTENTERS')) {
      roles.push('only_my_tenders')
    }
    if (user_tender_set?.accessRole?.some(it => it.trim() == 'ADMIN')) {
      roles.push('admin')
    }

    const godModeRoles = ['QA', 'ADMIN', 'FRONTOFFICEEMPLOYEE', 'FRONTOFFICEADMIN']

    if (user_tender_set?.accessRole?.some(it => godModeRoles.includes(it.trim()))) {
      roles.push('good-mode-access')
    }
    payload.acl.change(roles)

    if (Vue.prototype && Vue.prototype.$log) {
      Vue.prototype.$log('ACL:', payload.acl.get )
    }

    // https://github.com/stalniy/casl/tree/master/packages/casl-vue  https://casl.js.org/v4/en/ https://casl.js.org/v4/en/package/casl-vue

    // can('use', 'useCriteriaCards')
    if (hasTenders && st_settings) {

      // + Доступ к "Мои аккредитованные поставщики"
      if (st_settings.accessAccreditedSuppliers) {
        can('access', 'AccreditedSuppliers')
      }

      // Доступ к настройке возможности участия в тендере (на продажу) физ лиц
      if (st_settings.allowIndividualsParticipation) {
        can('set', 'AllowIndividualsParticipation', st_settings.allowIndividualsParticipation )
      }

      // Показати опцію вимкнення/включення ануляціі пропозицій учасником в тендері
      if (st_settings.isAllowParticipantCancelBid) {
        can('set', 'IsAllowParticipantCancelBid', st_settings.isAllowParticipantCancelBid )
      }

      // Детальна приведена ціна (выводим 5 знаков)
      if (st_settings?.detailedReducePrice) {
        can('is', 'detailedReducePrice')
      }
      // Отображать IP адрест поставщика в предложениях по тендеру
      if (st_settings?.tenderProposalShowIp) {
        can('is', 'tenderProposalShowIp')
      }
      // Приховувати перегляди торгів учасниками на прийомі пропозицій або аукціоні, а також інформацію по учаснику під час звернення
      if (st_settings?.hideViewByParticipantsDuringBidReceptionOrAuction) {
        can('is', 'hideViewByParticipantsDuringBidReceptionOrAuction')
      }

      // Показывать Ip адреса в интерфейсе CRM Мои поставщики
      if (st_settings?.showFieldIpInMySuppliers) {
        can('is', 'showFieldIpInMySuppliers')
      }
      // Копирование предложений на аукционе https://app.clickup.com/t/8696dg8v3
      if (st_settings?.copyQualifiedBidsToAuction) {
        can('is', 'copyQualifiedBidsToAuction')
      }


      // + Минимальный шаг торгов
      // +  Максимальный шаг торгов
      if ( st_settings.minBidStep || st_settings?.maxBidStep) {
        can('choose', 'Step',  { step: {$gte: st_settings.minBidStep || 0, $lte: st_settings.maxBidStep }})
      }

      // Разрешить возвращать коммерческий тендер на сайт
      if (st_settings.allowReturnTenderToSite) {
        can('return', 'TenderToSite')
      }

      // Скрывать предложения участников до снятия тендера с сайта
      if (st_settings.hideProposalsUntilRemoveTenderFromSite) {
        can('set', 'hideProposalsUntilRemoveTenderFromSite')
      }

      // Разрешить (Продление на приеме предложений/ аукционе)
      if (st_settings.tenderProlongationAvailable) {
        can('prolong', 'Tender')
      }
      /** Максимальный период когда можно вернуть тендер на прием предложений с терминальных статусов
      * "X;Y" X - кол-во дней Y - кол-во часов
      * Учитываем только дни!!!
      */
      can('prolong', 'maxProlongationPeriod',  st_settings.maxProlongationPeriod)

      // + Возможность указывать шаг торгов и начальную ставку
      // NONE NONE
      // NOT_AVAILABLE NOT_AVAILABLE
      // AMOUNT AMOUNT
      // MINIMAL_STEP MINIMAL_STEP
      // AMOUNT_AND_MINIMAL_STEP AMOUNT_AND_MINIMAL_STEP
      if (st_settings.availableBudgetType) {
        can('set', 'BudgetType', st_settings.availableBudgetType )
      }

      // + Отмена тендера. Доступ
      if (st_settings.allowEarlyRemoveTenderFromSite) {
        can('earlyRemove', 'Tender')
      }
      // + Отмена тендера. Доступ
      if (st_settings.cancelTenderAvailable) {
        can('cancel', 'Tender')
      }

      // bidStepType
      // Тип шага тзменения предложения
      // PERCENT PERCENT
      // ABSOLUTE ABSOLUTE
      // CHOOSE CHOOSE
      if (st_settings.bidStepType) {
        can('set', 'bidStepType', st_settings.bidStepType )
      }

      //  +  Доступно использование карт критериев
      // todo пока всегда отключено

      // eslint-disable-next-line no-constant-condition
      if (st_settings.criteriaCardsAvailable) {
        can('use', 'useCriteriaCards')
      }

      // + Минимальное количество дней(часов) для пребывания тендера на сайте "X;Y" X - кол-во дней Y - кол-во часов. Работает только по одному значению (приоритет отдан дням)
      can('set_minimal', 'daysWebTender',  st_settings.daysWebTender)

      // ? Удаление предложений. Доступ
      if (st_settings.deleteBidAvailable) {
        can('delete', 'Bid')
      } else {
        cannot('delete', 'Bid')
      }

      // + Доступно указания адреса поставки
      if (st_settings.deliveryAddressAvailable) {
        can('set', 'deliveryAddress')
      }

      // + Редактирование времени окончания приема предложений
      if (st_settings.editEndTime) {
        can('edit', 'EndTime')
      }

      // + Возможность включить в тендере скрытие лучшей цены до подачи предложения
      if (st_settings.hideBestPriceBeforeBidding) {
        can('hide', 'BestPriceBeforeBidding')
      }

      // + Возможность выбирать для тендера вид цены: с НДС / без НДС
      if (st_settings.includeVat) {
        can('include', 'vat')
      }

      // + Максимальное количество лотов, разрешенное в одном тендере
      if (st_settings?.maximumLotsCountPerTender) {
        can('available', 'LotsPerTender', { lots: {$lte: st_settings?.maximumLotsCountPerTender}})
      }

      // + Ліміт незареєстрованих контактів в одному запрошенні (GrowthBook unknownEmailsInviteLimit; 0 — активний ліміт)
      const unknownEmailsLimit = st_settings?.unknownEmailsPerInviteLimit
      if (state.growthBook?.unknownEmailsInviteLimit && Number.isInteger(unknownEmailsLimit) && unknownEmailsLimit >= 0) {
        can('invite', 'UnknownEmailsLimit', { limit: unknownEmailsLimit })
      }

      // ?  Предлагать перейти к просмотру тендера при публикации тендера
      if (st_settings?.offerToGoToTender) {
        can('offer', 'ToGoToTender')
      }

      // ? Разрешена отправка подтверждения цены
      if (st_settings?.priceConfirmationSendAllowed) {
        can('send', 'priceConfirmation')
      }

      // ? Запрос причины выбора менеджером победителя не с минимальной ценой
      if (st_settings?.reasonChangeChoice) {
        can('ask', 'reasonChangeChoice')
      }

      // Доступ организатора к функции отправки личных сообщений участнику
      if (st_settings?.sendPrivateMessageToBidderAvailable) {
        can('set', 'privateMessageToBidder')
      }

      // яка різниця або чи є на ux ? Доступно указания адреса покупетеля
      if (st_settings?.suplierAddressAvailable) {
        can('set', 'suplierAddress')
      }

      // Режим планування публікації тендеру
      // DISABLE - Виключено
      // PUBLISH - Запланована публікація тендера
      // PUBLISH_WITH_MAIL - Запланована публікація тендера а також попередня розсилка
      if (st_settings?.tenderPublicationPlaningMode) {
        can('set', 'tenderPublicationPlaningMode', st_settings?.tenderPublicationPlaningMode)
      }

      // Доступ к информации о просмотре тендера
      if (st_settings?.showTenderViews) {
        can('set', 'tenderViews')
      }

      // для доступа к импорту лотов
      if (st_settings?.allowedImportLots) {
        can('import', 'lots')
      }

      // доступ к загрузке документов на анализе предложений
      if (st_settings?.addAdditionalAttachmentsAfterTendering) {
        can('set', 'addAdditionalAttachmentsAfterTendering')
      }
      // доступ к загрузке внешних документов на анализе предложений
      if (st_settings?.publicTenderResultsAttachments) {
        can('set', 'publicTenderResultsAttachments')
      }
      // Правило аварійної закупівлі
      // https://app.clickup.com/t/85zt8nyaj
      if (st_settings?.hasUrgentPurchaseFlag) {
        can('set', 'hasUrgentPurchaseFlag')
      }

      // Використовувати загальне погодження (новий БП зі стадіями)
      // https://app.clickup.com/t/85zrvkv3t
      if (st_settings?.useCommonAgreements) {
        can('set', 'useCommonAgreements')
      }
      // Использовать шаблоны категорий
      // https://app.clickup.com/t/1y7zcew
      if (st_settings?.useClassificationTemplates) {
        can('set', 'useClassificationTemplates')
      }
      //доступ к автоматизации
      // https://app.clickup.com/t/8678xaz44
      if (st_settings?.automationAvaliable) {
        can('use', 'automationAvaliable')
      }


      //  возможность менять победителя тендера  На статусе -  Завершено
      if (st_settings?.tenderWinnerChangeMethodAccessibility) {
        can('change', 'tenderWinnerChangeMethodAccessibility')
      }
      //  Отображать переход в старый кабинет
      if (st_settings?.redirectToOldCabinetMethodAccessibility) {
        can('set', 'redirectToOldCabinetMethodAccessibility')
      }
      //  Скрытие цен Участников на этапе «Преквалификация»
      if (st_settings?.hidePricesOnPrequalification) {
        can('hide', 'PricesOnPrequalification')
      }
      //  Доступ к странице Риск-индикаторов
      if (st_settings?.riskIndicatorsPageAvailable) {
        can('hide', 'RiskIndicatorsPageAvailable')
      }
      if (st_settings?.availableSubmitForeignSupplierBid) {
        can('have', 'ForeignSupplierBid')
      }
      //  Возможность загружать файлы до 100 мб
      if (st_settings?.incrementUploadingFileSize) {
        can('upload', 'incrementedFileSize')
      } else {
        cannot('upload', 'incrementedFileSize')
      }

      // Возможность копировать предложения по образцу
      if (st_settings?.allowBidCopy) {
        can('copy', 'bids')
      } else {
        cannot('copy', 'bids')
      }
      // КонтрПредложения на приеме предложений
      if (st_settings?.counteroffersOnTendering) {
        can('counteroffer', 'OnTendering')
      } else {
        cannot('counteroffer', 'OnTendering')
      }

      // Стандартное автоматическое правило продления в тендере // використовується зараз через об'єкт налаштувань
      if (st_settings?.defaultTenderProlongRules) {
        can('have', 'defaultTenderProlongRules', st_settings?.defaultTenderProlongRules)
      } else {
        cannot('have', 'defaultTenderProlongRules')
      }

      if (st_settings?.hideInvitedListSearchDialog) {
        can('hide', 'InvitedListSearchDialog')
      } else {
        cannot('hide', 'InvitedListSearchDialog')
      }

      // Расширенный процесс добавление согласовантов
      if (st_settings?.forceBpmAdditionalAgreementTenderStatuses) {
        can('use', 'forceBpmAdditionalAgreementTenderStatuses')
      } else {
        cannot('use', 'forceBpmAdditionalAgreementTenderStatuses')
      }
      // Доступ к доп. полям
      if (st_settings?.availableAdditionalFields) {
        can('use', 'availableAdditionalFields')
      } else {
        cannot('use', 'availableAdditionalFields')
      }
      // Разрешение на создание дубликатов лотов
      if (st_settings?.allowLotDuplication) {
        can('use', 'allowLotDuplication')
      } else {
        cannot('use', 'allowLotDuplication')
      }
      //  Відображати фільтр нерезидентів (при запрошенні)
      if (st_settings?.showTenderResidentFilter) {
        can('show', 'tenderResidentFilter')
      } else {
        cannot('show', 'tenderResidentFilter')
      }
      // Перевірка вимог в документі з AI
      if (st_settings?.aiRequirementsFromDocument) {
        can('use', 'aiRequirementsFromDocument')
      } else {
        cannot('use', 'aiRequirementsFromDocument')
      }
      // Відобразити хто подав пропозицію на аналізі переглядів
      if (st_settings?.showBiddedLotsInTenderViditPage) {
        can('show', 'showBiddedLotsInTenderViditPage')
      } else {
        cannot('show', 'showBiddedLotsInTenderViditPage')
      }
      // #869earnc3 Функціонал «Новий етап»
      if (st_settings?.allowCreateNewStageAfterUnsuccessfulTender) {
        can('show', 'allowCreateNewStageAfterUnsuccessfulTender')
      } else {
        cannot('show', 'allowCreateNewStageAfterUnsuccessfulTender')
      }
      // #869edycht Відображення опитувальника (поля для вводу причини) при виборі переможця не за найкращою вартістю
      if (st_settings?.requireNonBestPriceWinnerReason) {
        can('show', 'requireNonBestPriceWinnerReason')
      } else {
        cannot('show', 'requireNonBestPriceWinnerReason')
      }


      //https://app.clickup.com/t/2169750/8699xcruh
      if (st_settings?.allowGroupLotsXlsImportExport) {
        can('show', 'allowGroupLotsXlsImportExport')
      } else {
        cannot('show', 'allowGroupLotsXlsImportExport')
      }
      // https://app.clickup.com/t/2169750/869ct6w3d
      if (st_settings?.useCriterionKindSelection) {
        can('show', 'useCriterionKindSelection')
      } else {
        cannot('show', 'useCriterionKindSelection')
      }
      // https://app.clickup.com/t/2169750/869bcvtu8
      if (st_settings?.useGroupAccreditations) {
        can('show', 'useGroupAccreditations')
      } else {
        cannot('show', 'useGroupAccreditations')
      }
      //https://app.clickup.com/t/869ahp1ta
      if (st_settings?.useGroupLots) {
        can('show', 'useGroupLots')
      } else {
        cannot('show', 'useGroupLots')
      }
      // https://app.clickup.com/t/869d1vjtb
      if (st_settings?.useAccreditationDocumentRequirements) {
        can('show', 'useAccreditationDocumentRequirements')
      } else {
        cannot('show', 'useAccreditationDocumentRequirements')
      }
      // https://app.clickup.com/t/2169750/869dtcd5t
      if (st_settings?.allowAccreditationTestGroups) {
        can('show', 'allowAccreditationTestGroups')
      } else {
        cannot('show', 'allowAccreditationTestGroups')
      }
      
    }

    Vue.prototype.$ability.update(rules)

    return new Promise((resolve) => {
      resolve(settings)
    })
  },
  setMenu({commit, state}, payload) {
    return new Promise((resolve) => {
      let links = payload.router.options.routes[0].children.filter((x) => x.meta && x.meta.isMenu )

      const currentOrgId = state?.currentOrganization?.organizationItId

      const checkDisabled = (item) => {
        const hasAccess = item.meta.rule && payload.acl.check(item.meta.rule)
        const correctOrg = !item.meta.needOrg || (item.meta.needOrg && currentOrgId)

        return !hasAccess || !correctOrg
      }

      links.map(i => i.disabled = checkDisabled(i))

      // if ( payload.acl.check('loading') )
      /*if (payload.acl.not.check('tendersView') ) {
        links = links.filter(el => el.meta.rule != 'tendersView' && !el.meta.link)
      }
      if (payload.acl.not.check('onlyApps')) {
        links = links.filter(el => el.meta.rule != 'onlyApps')
      }*/
      if (payload.acl.not.check('stopListView')) {
        links = links.filter(el => el.name != 'stopLists')
      }
      if (payload.acl.not.check('tenderAdmin')) {
        links = links.filter(el => el.meta.rule != 'tenderAdmin')
      }
      if (!Vue.prototype.$ability.can('use', 'availableAdditionalFields')) {
        links = links.filter(el => el.name != 'additionalFieldsConstructor')
      }
      if (!payload?.settings?.tenderSettings?.riskIndicatorsPageAvailable) {
        links = links.filter(el => el.path != 'risk indicators')
      }

      commit('setRouterLinks', links.map(el => {
        delete el.component
        return el
      }))
      resolve()
    })
  },
  async getContractNumberAndTariff(context, payload) {
    let info = context.getters.getContractNumberAndTariff
    if (!info || !Object.keys(info)?.length || payload) {
      return await settingsApi.getContractNumberAndTariff()
        .then(res => {
          context.commit('setContractNumberAndTariff', res)
          return res
        })
    } else {
      return info
    }
  },
  async configureSatismeter({state, commit}, payload) {
    if (state?.settings?.userAccess?.accessType != 'ALLOW') {
      return
    }
    await settingsApi.getNpsUserData()
      .then(res => {
        commit('setNpsSettings', res.data.npsUser)
        commit('setSurveySettings', res.data.survey)
        return res
      })
    if (state.npsUserData) {
      let nps = JSON.parse(JSON.stringify(state.npsUserData))
      Vue.prototype.$set(nps.traits, 'page',  payload)
      var satismeter = require('@/plugins/satismeter.js')
      satismeter(nps)
    }
  },
  async getInstructions({ state, commit }, payload) {
    if (state?.settings?.userAccess?.accessType != 'ALLOW') {
      return
    }
    let info = state.instructions
    if (!info || !Object.keys(info)?.length || payload) {
      return await settingsApi.getInstructions()
        .then(res => {
          commit('setInstructions', res)
          return res
        })
    } else {
      return info
    }
  },
  async getTimezones(context, lang) {
    lang = lang || 'uk'
    let info = context.getters.getTimezones
    if (!info[lang] || !Object.keys(info[lang])?.length) {
      return await settingsApi.getTimezones(lang)
        .then(res => {
          const timezones = {
            lang,
            value: res
          }
          context.commit('setTimezones', timezones)
          return res
        })
    } else {
      return info[lang]
    }
  },

}

export default actions
